module.exports = __webpack_public_path__ + "media/images/icon_list/send-2d0ffea527347f6986e4061f2d0b2844.svg";